import api from "@/utils/api";
import { toast } from "sonner";

const KEY = "ivoliq_free_timer_v1";
const LOCK = "ivoliq_free_timer_import_lock";

/** Übernimmt Einträge des kostenlosen Browser-Timers (SEO-Seite) ins Konto. Läuft einmalig, räumt localStorage auf. */
export async function importFreeTimerEntries() {
  let state;
  try { state = JSON.parse(localStorage.getItem(KEY)); } catch { return null; }
  const entries = (state?.entries || []).filter(e => e.seconds > 0);
  if (!entries.length || sessionStorage.getItem(LOCK)) return null;
  sessionStorage.setItem(LOCK, "1");
  try {
    const { data } = await api.post("/time-entries/import-free-timer", {
      entries: entries.map(e => ({ project: e.project || "Ohne Projekt", start: e.start, seconds: Math.round(e.seconds) })),
    });
    if (data.imported > 0) {
      localStorage.setItem(KEY, JSON.stringify({ running: state.running || null, entries: [] }));
      toast.success(`${data.imported} Zeiteintr${data.imported === 1 ? "ag" : "äge"} aus dem kostenlosen Timer übernommen`, {
        description: data.project_names.length ? `Projekt${data.project_names.length > 1 ? "e" : ""}: ${data.project_names.join(", ")}` : undefined,
        duration: 8000,
      });
    }
    return data;
  } catch (e) {
    console.error("Timer-Import fehlgeschlagen", e);
    sessionStorage.removeItem(LOCK);
    return null;
  }
}
